import { FiShield, FiLock } from "react-icons/fi";

export const settingsSections = [
  {
    key: "security",
    label: "Security",
    items: [
      {
        key: "change-password",
        label: "Change Password",
        description: "Update the password you use to sign in to your account.",
        icon: FiLock,
      },
      {
        key: "two-factor",
        label: "Two-Factor Authentication",
        description:
          "Add an extra layer of protection to your account with an authenticator app.",
        icon: FiShield,
      },
    ],
  },
];

export const getDefaultSettingsPath = () => {
  const firstSection = settingsSections[0];
  const firstItem = firstSection?.items?.[0];
  if (!firstSection || !firstItem) return "/settings";
  return `/settings/${firstSection.key}/${firstItem.key}`;
};

export const findSettingsItem = (sectionKey, itemKey) => {
  const section = settingsSections.find((s) => s.key === sectionKey);
  const item = section?.items?.find((i) => i.key === itemKey);
  return section && item ? { section, item } : null;
};
